<p-toast></p-toast>
<p-card>
    <div class="flex flex-col items-center gap-4 justify-between min-h-[400px]   p-1 lg:p-4">
        <img alt="Sisdemanda" height="98" ngSrc="logo.png" width="300"/>
        <div class="w-full space-y-2">
            <label class="block text-sm text-gray-700" for="tokenInput">Digite seu
                e-mail</label>
            <input [formControl]="emailCtrl" class="w-full p-2 border rounded"
                   id="emailInput" name="email"
                   type="email"/>
        </div>
        <p-button (click)="sendEmailForToken()"
            (keydown.enter)="$event.preventDefault(); sendEmailForToken()"
            (keydown.space)="$event.preventDefault(); sendEmailForToken()" [disabled]="loading"
                  class="w-full" styleClass="btn-gray">
            @if (!loading) {
                <app-icon-enviar-token class="mr-2"></app-icon-enviar-token>
                Enviar token
            }
            @if (loading) {
                <i class="pi pi-spin pi-spinner mr-2"></i>
                Enviando token
            }
        </p-button>
    </div>
</p-card>
